import { Table, TableBody } from '@mui/material';
import { SectionWrapper, ValueRow } from '../../../components/tableComponents';

type props = {
  signatures: string[]
}

const TxSignatures = ({signatures}: props) => {
  return (
    <>
        <h4>Signatures:</h4>
        <SectionWrapper>
          <Table  aria-label="overview snapshot table">
              <TableBody>
                  {signatures.map((sig) => {
                    return (
                      <ValueRow value={sig} key={sig}/>
                    )
                  })}
              </TableBody>
          </Table>
        </SectionWrapper>
    </>
  )
}

export default TxSignatures;